export default __webpack_public_path__ + "static/media/cause_gold.92de64b9.svg";